import React, { useEffect } from 'react';
import { saveVisit } from '../../api/visitTrackerService';

const ServerError = () => {
    useEffect(() => {
        saveVisit('server-error');
    }, []);

    return (
        <div className="page-center">
            <h1>Something went wrong</h1>
            <p>Sorry, there was a server error. Please try again later.</p>
            <a href="/" className="btn btn-outline">Go home</a>
        </div>
    );
};

export default ServerError;
